/**
 * Social connect landing page — Meta OAuth callback redirects vendors here.
 * We use this thin page to (a) authenticate the user, then (b) bounce them
 * to their role's dashboard while preserving `meta_status` + `meta_reason`
 * query params so MetaSocialConnectCard can show a toast.
 */
import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const SocialConnectLanding = () => {
  const { user, loading } = useAuth();
  const [searchParams] = useSearchParams();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-text-secondary">
        Finishing up…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  let dashboardPath = '/dashboard';
  if (user.role === 'vendor') dashboardPath = '/dashboard/vendor';
  else if (user.role === 'professional') dashboardPath = '/dashboard/professional';

  // Pass meta_status + meta_reason forward
  const qs = searchParams.toString();
  return <Navigate to={`${dashboardPath}${qs ? `?${qs}` : ''}`} replace />;
};

export default SocialConnectLanding;
